import React, { Suspense } from 'react';

import ReactDOM from 'react-dom/client';
import './stili/index.css';
import './stili/App01.css';

import * as serviceWorkerRegistration from './serviceWorkerRegistration.ts';
import reportWebVitals from './reportWebVitals.ts';
import {
  createBrowserRouter,
  createMemoryRouter,
  RouterProvider,
  redirect,
  Outlet,

} from "react-router-dom";
import './i18n';

//import App from './pagine/App';
const App  = React.lazy(() => import( './pagine/App'));

const Config  = React.lazy(() => import( './pagine/Config'));

const ProfiliUtenti  = React.lazy(() => import( './pagine/ProfiliUtenti'));


const AbbonamentoPage= React.lazy(() => import( './pagine/AbbonamentoPage.jsx'));
const Datifatturazione  = React.lazy(() => import( './pagine/Datifatturazione'));
const Magazzino  = React.lazy(() => import( './pagine/Magazzino'));
const Report  = React.lazy(() => import( './pagine/Report'));



//const Ordini  = React.lazy(() => import( './pagine/Ordini'));

const HomeUtente  = React.lazy(() => import( './pagine/HomeUtente'));

// import i18n (needs to be bundled ;))

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
/*root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);*/

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,

    children: [
      
      {
        path: "/homeUtente",
        element: <Suspense fallback={<div>Loading...</div>}><HomeUtente /> </Suspense>,
      },
      
      {
        path: "/Config",
        element: <Suspense fallback={<div>Loading...</div>}><Config/> </Suspense>,
      },

      {
        path: "/ProfiliUtenti",
        element: <Suspense fallback={<div>Loading...</div>}><ProfiliUtenti/> </Suspense>,
      },
      
       
         {
        path: "/Abbonamento",
        element: <Suspense fallback={<div>Loading...</div>}><AbbonamentoPage/> </Suspense>,
      },
         {
        path: "/Magazzino",
        element: <Suspense fallback={<div>Loading...</div>}><Magazzino/> </Suspense>,
      },
               {
        path: "/Report",
        element: <Suspense fallback={<div>Loading...</div>}><Report/> </Suspense>,
      },
         {
        path: "/Datifatturazione",
        element: <Suspense fallback={<div>Loading...</div>}><Datifatturazione/> </Suspense>,
      },
      /*{
        path: "/Ordini",
        element: <Suspense fallback={<div>Loading...</div>}><Ordini/> </Suspense>,
      }*/
      ]
  }
]);
root.render(
  <React.StrictMode>  
          <RouterProvider router={router} />
      </React.StrictMode>
);
//attenzione stric mode geneera due chiamate per useeffect ma non è attivo in produzione



// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();


